import { baseApi } from "../../redux/baseAPI";

export const eyeExamsApi = baseApi.injectEndpoints({
  tagTypes: ["LIST", "EyeExam", "EyeExamMeta"],
  endpoints: (builder) => ({
    getEyeExams: builder.query({
      query: (data) => {
        return {
          url: `/eye_exams/index.json`,
          method: "GET",
          params: data,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: (result) =>
        result.data
          ? [
              ...result.data.map(({ id }) => ({ type: "EyeExam", id })),
              { type: "EyeExam", id: "LIST" },
            ]
          : [{ type: "EyeExam", id: "LIST" }],
    }),
    getPreviousEyeExamsResult: builder.query({
      query: (data) => {
        return {
          url: `/eye_exams/get_previous.json`,
          method: "GET",
          params: data,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getEyeExamMeta: builder.query({
      query: (data) => ({ url: `/eye_exams_meta/index.json`, method: "GET", params: data }),
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["EyeExamMeta"],
    }),
    saveEyeExamForm: builder.mutation({
      query: (payload) => ({
        url: `/eye_exams/save_${payload.component}.json`,
        method: "POST",
        data: payload,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
      // invalidatesTags: ["EyeExam"],
    }),
    getSummaryEyeExam: builder.query({
      query: (data) => {
        return {
          url: `/eye_exams/summary.json`,
          method: "GET",
          params: data,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    viewEyeExam: builder.query({
      query: (data) => {
        return {
          url: `/eye_exams/view.json`,
          method: "GET",
          params: data,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    attachEyeExamWithNote: builder.mutation({
      query: (payload) => {
        return {
          url: `/notes/update_exam_attachment.json`,
          method: "POST",
          data: payload,
        };
      },
      transformResponse: (response, meta, arg) => response,
    }),
    addNewKeyInMeta: builder.mutation({
      query: (payload) => {
        return {
          url: `/eye_exams_meta/add.json`,
          method: "POST",
          data: payload,
        };
      },
      transformResponse: (response, meta, arg) => response,
      invalidatesTags: ["EyeExamMeta"],
    }),
    printEyeExamSummary: builder.query({
      query: (data) => {
        return {
          url: `/eye_exams_meta/print_summary.json`,
          method: "GET",
          params: data,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
  }),
});

export const {
  useGetEyeExamsQuery,
  useGetPreviousEyeExamsResultQuery,
  useGetEyeExamMetaQuery,
  useSaveEyeExamFormMutation,
  useGetSummaryEyeExamQuery,
  useViewEyeExamQuery,
  useAttachEyeExamWithNoteMutation,
  useAddNewKeyInMetaMutation,
  usePrintEyeExamSummaryQuery,
} = eyeExamsApi;
